import type { RouteLocationRaw } from 'vue-router'

export type CardHeader = {
  line1: string
  line2: string
}

export type CardHrefLink = {
  text: string
  href: string
}

export type CardRouteLink = {
  text: string
  to: RouteLocationRaw
}

export type CardLink = CardHrefLink | CardRouteLink

export type CardOtherLink = CardLink & {
  isHiddenWithoutIod?: boolean
}

export function isHrefLink(link: CardLink): link is CardHrefLink {
  return 'href' in link
}
